const getCreditBalanceForCheckoutCurrency = (state: App.State) =>
  state.auth.account.creditsByCurrency[state.checkout.cart.currencyCode]?.balance ?? 0

export default getCreditBalanceForCheckoutCurrency
